/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string, agrs?: string[]): string {
    const decimal: number = 10;
    const limit = parseInt(agrs[0], decimal);
    const trail = agrs.length > 1 ? agrs[1] : '...';

    return value.length + trail.length > limit
      ? value.substring(0, limit - trail.length) + trail
      : value;
  }
}
